import { useState } from 'react';
import { alertaGeneral } from '../../utils/alertas';
import apiClient from '../../utils/axiosPetition';
import { getAndValidateToken, handleInvalidToken } from '../../utils/tokenValidation';
import { openEpaycoCheckout } from '../../utils/epaycoCheckout';
import MembresiaPrestadorPlanModal from './MembresiaPrestadorPlanModal';

const BotonUpgradeEpayco = ({
  disabled = false,
  className = '',
  children = 'Actualizar a Premium',
  onSuccess,
  onError,
}) => {
  const [loading, setLoading] = useState(false);
  const [modalPrestadorOpen, setModalPrestadorOpen] = useState(false);
  const [doctorId, setDoctorId] = useState(null);

  const handleUpgradePaciente = async (userId) => {
    const response = await apiClient.post('/api/epayco/procesar-pago', {
      tipo: 'membresia',
      userId,
      amount: null,
    });
    const epaycoData = response.data;
    await openEpaycoCheckout(epaycoData);
    onSuccess?.(epaycoData);
  };

  const handleUpgrade = async (e) => {
    e.preventDefault();
    if (loading || disabled) return;

    setLoading(true);

    try {
      const tokenValidation = getAndValidateToken();

      if (!tokenValidation.isValid) {
        handleInvalidToken(tokenValidation);
        throw new Error(tokenValidation.error);
      }

      const { decoded } = tokenValidation;
      const userId = decoded.id || decoded.userId;
      const role = decoded.role;

      if (!userId) {
        throw new Error('No se pudo obtener el ID del usuario');
      }

      if (role === 'doctor') {
        const docId = decoded.doctorId || localStorage.getItem('doctorId');
        if (!docId) {
          throw new Error('No se encontró el perfil del profesional');
        }
        setDoctorId(docId);
        setModalPrestadorOpen(true);
        return;
      }

      await handleUpgradePaciente(userId);
    } catch (error) {
      console.error('Error al procesar membresía premium:', error);

      alertaGeneral({
        titulo: 'Error',
        messageHtml: error.response?.data?.message || error.message || 'Ocurrió un error al procesar el pago con ePayco',
        isError: true,
      });

      onError?.(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className={`w-full px-3 py-1 ${disabled ? 'bg-yellow-300' : 'bg-yellow-500 hover:bg-yellow-600'} text-white rounded-lg focus:outline-none border border-[#6e787aff] ${className}`}
        type="button"
        onClick={handleUpgrade}
        disabled={disabled || loading}
      >
        {loading ? 'Abriendo pago...' : children}
      </button>

      <MembresiaPrestadorPlanModal
        isOpen={modalPrestadorOpen}
        onClose={() => setModalPrestadorOpen(false)}
        doctorId={doctorId}
      />
    </>
  );
};

export default BotonUpgradeEpayco;
